import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {User} from '../../model/User';

export interface UserState {
    profile?: User;
}

const initialState: UserState = {
    profile: undefined,
};

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUserProfile(state, action: PayloadAction<User | undefined>) {
            state.profile = action.payload;
        },
        clearUserProfile(state) {
            state.profile = undefined;
        },
    },
});

export const {setUserProfile, clearUserProfile} = userSlice.actions;
export default userSlice.reducer;
